var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "invoice-input" }, [
    _c("div", { staticClass: "file-upload" }, [
      _c(
        "label",
        {
          staticClass:
            "flex invoice-label items-center font-normal ml-1 mb-1 text-sm font-outfit",
          attrs: { for: "fileUpload" },
        },
        [
          _c(
            "span",
            { staticClass: "custom-file-input-icon" },
            [_c("UploadFileIcon")],
            1
          ),
          _vm._v(" Upload "),
          _c(
            "Tooltip",
            {
              staticClass: "flex items-center",
              attrs: {
                variant: _vm.TooltipVariants.DARK,
                title:
                  "The reference number provided by the third party platform on the original invoice.",
                tooltipClasses: "w-56",
                placement: "top",
              },
            },
            [
              _c(
                "span",
                { staticClass: "inline-block mx-1" },
                [_c("InfoIcon")],
                1
              ),
            ]
          ),
          _vm._v(" : "),
        ],
        1
      ),
      _c("form", { ref: "form" }, [
        _c("input", {
          attrs: {
            type: "file",
            id: "fileUpload",
            accept: ".pdf, .doc, .docx, .jpg, .jpeg",
          },
          on: { change: _vm.onChange },
        }),
        _c("span", { staticClass: "invoice-file-text font-outfit" }, [
          _vm._v("or Drop Files"),
        ]),
      ]),
    ]),
    _vm.fileType
      ? _c("div", { staticClass: "relative pt-5" }, [
          _c(
            "div",
            { staticClass: "file-uploaded-block px-1 mb-3 flex items-center" },
            [
              _vm.isImage
                ? _c(
                    "div",
                    {
                      staticClass:
                        "uploded-file-image flex justify-center flex-col w-8 h-8",
                    },
                    [
                      _c("img", {
                        staticClass: "rounded-sm",
                        attrs: { src: _vm.filePreviewUrl, alt: "Preview" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.isPdf
                ? _c(
                    "div",
                    {
                      staticClass:
                        "uploded-file-image flex justify-center flex-col w-8 h-8",
                    },
                    [_c("PdfFileIcon")],
                    1
                  )
                : _vm._e(),
              _vm.isDoc
                ? _c(
                    "div",
                    {
                      staticClass:
                        "uploded-file-image flex justify-center flex-col w-8 h-8",
                    },
                    [
                      _c("MsWordIcon", {
                        staticClass: "bg-white p-1 rounded-sm",
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "uploded-file-details pl-2 mb-1.5" }, [
                _c(
                  "strong",
                  {
                    staticClass:
                      "file-name-upload block text-sm opacity-50 leading-4",
                  },
                  [_vm._v(_vm._s(_vm.fileName))]
                ),
                _c("span", { staticClass: "file-image-mb block text-xs" }, [
                  _vm._v(
                    _vm._s((_vm.fileSize / 1024 / 1024).toFixed(2)) + "MB"
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "cursor-pointer absolute top-7 right-2 w-5 h-5",
                    on: { click: _vm.resetFile },
                  },
                  [_c("CrosUpdataFile")],
                  1
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "upload-bg-bar h-1 rounded-lg relative" }, [
            _c(
              "div",
              {
                staticClass: "bg-blue h-1 rounded-lg",
                style: { width: _vm.uploadProgress + "%" },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "upload-bar-percentage upload-bar-percentage-full absolute font-normal font-outfit",
                  },
                  [_vm._v(_vm._s(_vm.uploadProgress) + "%")]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }